var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{attrs:{"flat":""}},[_c('q-card-section',[_c('div',{staticClass:"text-h6"},[_vm._v(_vm._s(_vm.$t('my_payments')))])]),_c('q-card-section',{staticClass:"q-pt-none row q-col-gutter-md"},[_c('div',{staticClass:"col-12"},[_c('list-financial',{attrs:{"idAffiliateFromAdmin":_vm.id}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }